export const EDITOR_KEY = process.env.REACT_APP_EDITOR_KEY;

export const app = {
  API_URL: process.env.REACT_APP_API_URL,
  WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL,
};

export default app;
